export enum ReviewsComponentTypes {
    CLASSIC = "classic",
    CAROUSEL = "carousel",
}

export enum WriteReviewFormMode {
    CLOSED = "closed",
    FORM_OPEN = "form-open",
    THANK_YOU_OPEN = "thank-you-open",
}

export enum SubmitReviewStatus {
    SUCCESS,
    FAIL_MISSING_PRODUCT_SELECTION,
    FAIL_MISSING_VARIANT_SELECTION,
    FAIL_INVALID_FIELDS,
    FAIL_API,
}

export enum ReviewDisclosureCode {
    SAMPLING = "sampling",
}

export const SideNames = ["One", "Two"];

export const NOT_SURE_VARIANT_CHOICE_SLUG = "not-sure";
export const REVIEW_VARIANT_NOT_SELECTED = "not-selected";
